import { Directive, effect, ElementRef, forwardRef, HostListener, inject, Injector, input, OnDestroy, signal, Type } from '@angular/core';
import { OverlayRef, OverlaysService, POSITION_TARGET, PositionTarget } from 'app/shared/ui/overlays';


@Directive({
    selector: '[uiDropdown]',
    exportAs: 'dropdown',
    providers: [
        { provide: POSITION_TARGET, useExisting: forwardRef(() => DropdownDirective) },
    ]
})
export class DropdownDirective implements PositionTarget, OnDestroy {

    isOpen = signal(false);

    uiDropdown = input.required<Type<unknown>>();

    inputs = input<Record<string, unknown>>();

    outputs = input<Record<string, unknown>>();

    elementRef = inject(ElementRef);

    getBoundingClientRect() {
        return this.elementRef.nativeElement.getBoundingClientRect();
    }

    private overlayRef: OverlayRef | null = null;

    private overlaysService = inject(OverlaysService);

    private injector = inject(Injector);

    constructor() {
        effect(() => {
            if (this.isOpen() && !this.overlayRef) {
                this.overlayRef = this.overlaysService.createOverlay(this.uiDropdown(), {
                    inputs: this.inputs(),
                    outputs: this.outputs(),
                    parentInjector: this.injector,
                });
                this.overlayRef.componentRef.onDestroy(() => {
                    this.overlayRef = null;
                    this.isOpen.set(false);
                });
            } else if (this.inputs() && this.isOpen() && this.overlayRef) {
                for (const [key, value] of Object.entries(this.inputs() ?? {})) {
                    this.overlayRef.componentRef.setInput(key, value);
                }
            } else if (!this.isOpen() && this.overlayRef) {
                this.overlayRef.dismiss('close');
            }
        });
    }

    @HostListener('document:click', ['$event'])
    onClick(event: Event) {
        const clickInDropdown = this.elementRef.nativeElement.contains(event.target);
        if (!clickInDropdown && this.isOpen()) {
            this.isOpen.set(false);
        }
    }

    ngOnDestroy() {
        if (this.overlayRef) {
            this.overlayRef.dismiss('host destroyed');
        }
    }
}
